import React, { Component } from 'react';
import './App.css';

import Geolocation from './components/Geolocation';
import Mapfit from './components/Mapfit';

class App extends Component {
  render() {
    return (
      <Geolocation
        render={({
          fetchingPosition,
          position: { coords: { latitude, longitude } = {} } = {},
          error,
          getCurrentPosition
        }) => {
          if (!latitude && !longitude && !fetchingPosition) {
            console.log('Let us fetch current position');
            // getCurrentPosition();
          }
          // console.log(
          //   { latitude, longitude },
          //   { fetchingPosition, error, getCurrentPosition }
          // );

          // TODO: lat/lng must be near Denmark

          const lat = latitude; // || 56.319695;
          const lng = longitude; // || 10.3773419;
          const zoom = 13;
          return (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0
              }}
            >
              <Mapfit lat={lat} lng={lng} zoom={zoom} />
              {/* <div className="App">
              <div className="App-intro">
                <button onClick={getCurrentPosition}>Get Position</button>
                {error && <div>{error.message}</div>}
                <pre>
                  latitude: {latitude} <br />
                  longitude: {longitude}
                </pre>
              </div>
            </div> */}
            </div>
          );
        }}
      />
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js